<template>
  <div class="settled">
    <headd :mobile_title="mobile_title"></headd>
    <div class="banner">
      <img src="../../static/ruzhu/kv.png" />
    </div>
    <div class="formbox container">
      <div class="box_title">填写信息</div>
      <div class="dbox_cell">
        <div class="dbox_name">姓名</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="info.name"
            placeholder="请输入"
            class="input"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">手机号码</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="info.tel"
            placeholder="请输入"
            class="input"
            maxlength="11"
          />
        </div>
      </div>
      <div class="dbox_cell">
        <div class="dbox_name">公司名称</div>
        <div class="dbox_input">
          <input
            type="text"
            v-model="info.company_name"
            placeholder="请输入"
            class="input"
          />
        </div>
      </div>
      <div class="dbox_cell" style="justify-content: flex-start;">
        <div class="dbox_name">上传</div>
        <div
          class="dbox_uploadd"
          v-for="(item, index) in info.imgJson"
          :key="index"
          @click="delImg($event)"
          :data-index="index"
          :style="{
            backgroundImage: 'url(' + www + item.thumbfilepath + ')'
          }"
        >
          <img class="delete" src="../../static/circle/icon_10.png" />
          <img :src="item.thumbfilepath" class="img" />
        </div>
        <div
          class="dbox_uploadd"
          @click="setImgarr"
          v-show="info.imgJson.length < 1"
        >
          <div class="upload">
            <img src="../../static/ruzhu/icon.png" />
          </div>
          <div class="upload_text">上传营业执照</div>
          <div class="upload_tip">只支持.jpg 格式</div>
        </div>
      </div>
      <div class="btn_save" @click="btn_save">立即申请</div>
    </div>
    <div class="formbox container">
      <div class="box_title">{{ dy_title_t1.title }}</div>
      <img class="box_img" :src="dy_title_t1.pagevalue" mode="widthFix" />
    </div>
    <div class="formbox container">
      <div class="box_title">{{ dy_title_t2.title }}</div>
      <img class="box_img" :src="dy_title_t2.pagevalue" mode="widthFix" />
    </div>
    <div class="formbox container">
      <div class="box_title">{{ dy_title_t3.title }}</div>
      <img class="box_img" :src="dy_title_t3.pagevalue" mode="widthFix" />
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import {
  getproviderApplyPageData,
  getprovideApply,
  getuploadProviderImg
} from "./api/api"; //引入api里面定义的方法
let inputElement = null;
import axios from "axios";
import headd from "@/components/head";
import foot from "@/components/foot";
import { MessageBox, Toast } from "mint-ui";

export default {
  data() {
    return {
      mobile_title: "服务商入驻",
      dy_title_t1: {
        title: "马上创业网服务优势",
        pagevalue: ""
      },
      dy_title_t2: {
        title: "马上创业网入驻条件",
        pagevalue: ""
      },
      dy_title_t3: {
        title: "马上创业网入驻流程",
        pagevalue: ""
      },
      info: {
        uid: "",
        name: "",
        tel: "",
        company_name: "",
        imgJson: []
      },
      www: this.common.www_img,
      apiurl: this.common.apiurl
    };
  },
  mounted() {
    //console.log(this.www);
    this.regPageDataList();
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  methods: {
    async regPageDataList() {
      var _self = this;
      const res = await getproviderApplyPageData();
      var data = res.data.data;
      _self.dy_title_t1 = data.t1;
      _self.dy_title_t2 = data.t2;
      _self.dy_title_t3 = data.t3;
    },

    setImgarr() {
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("providerimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadProviderImg", formData, config)
              .then(uploadFileRes => {
                console.log(uploadFileRes.data);
                var res = uploadFileRes.data;
                if (res.status == 1) {
                  that.info.imgJson.push(uploadFileRes.data.data);
                } else {
                  that.$toast.error(res.msg);
                }
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);

                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });
                inputElement = null;
              });
          };
        }
      }
    },

    delImg(e) {
      //console.log(e)
      var _self = this;
      var index = e.currentTarget.dataset.index;
      MessageBox.confirm("是否删除图片")
        .then(action => {
          Toast({
            message: "删除成功"
          });
          var imgJson = _self.info.imgJson;
          imgJson.splice(index, 1);
          _self.info.imgJson = imgJson;
        })
        .catch(() => {
          Toast({
            message: "已取消删除"
          });
        });
    },
    async btn_save() {
      var _self = this;
      var data = _self.info;
      var phone_reg = /^1[3456789]\d{9}$/;
      if (data.name == "") {
        this.$toast("请输入名字");

        return false;
      }

      if (data.tel == "") {
        this.$toast("请输入电话");

        return false;
      } else {
        if (!phone_reg.test(data.tel)) {
          this.$toast("手机号码格式错误");

          return false;
        }
      }
      if (data.company_name == "") {
        this.$toast("请输入公司名称");

        return false;
      }
      if (data.imgJson.length == 0) {
        this.$toast("请上传图片");

        return false;
      }
      var parm = {
        uid: localStorage.getItem("userId"),
        name: data.name,
        tel: data.tel,
        company_name: data.company_name,
        imgJson: JSON.stringify(data.imgJson)
      };

      const res = await getprovideApply(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.info.name = "";
        _self.info.tel = "";
        _self.info.company_name = "";
        _self.info.imgJson = [];
      } else {
        // this.$message({
        //   message: res.msg
        // });
      }
    }
  },
  beforeCreate: function() {
    document.getElementsByTagName("body")[0].className = "body_back";
  },
  beforeDestroy: function() {
    document.body.removeAttribute("class", "body_back");
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}
.body_back {
  @media (max-width: 991px) {
    background: #f2f2f2;
  }
}
.formbox {
  width: 8rem;

  @media (max-width: 991px) {
    margin: 0.3rem 0.32rem;
    width: 6.86rem !important;
    padding: 0.4rem !important;
    height: auto;
    background: #ffffff;
    box-shadow: 0 0.04rem 0.14rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.2rem;
    flex-direction: column;
    .dbox_upload {
      width: 6.06rem;
      height: 2.92rem;
      background: rgba(196, 196, 204, 0.1);
      border-radius: 0.22rem;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      background-size: cover;
      background-position: center;

      .upload {
        width: 1rem;
        height: 0.83rem;
        margin-bottom: 0.23rem;

        img {
          width: 1rem;
          height: 0.83rem;
        }
      }

      .upload_text {
        height: 0.42rem;
        font-size: 0.3rem;

        color: #1b1c33;
        line-height: 0.42rem;
      }

      .upload_tip {
        height: 0.42rem;
        font-size: 0.3rem;

        color: #8d8e99;
        line-height: 0.42rem;
      }

      .delete {
        position: absolute;
        top: 0;
        right: 0;
        width: 0.4rem;
        height: 0.4rem;
      }

      .img {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
}
.settled {
  flex-direction: column;
  width: 100%;
  .banner {
    width: 100%;

    img {
      width: 100%;
    }
  }
}
.dbox_upload {
  border: 0 !important;
  background: #f2f2f2 !important;
  width: 3rem !important;
  //height: 1.52rem !important;
  .up_img {
    position: relative;
    width: 3rem;
    height: 3rem;
    background-position: center;
    .delete {
      top: -0.1rem;
      right: -0.1rem;
    }
  }
}
.dbox_name {
  @media (max-width: 991px) {
    font-size: 0.26rem !important;
  }
}
.input {
  @media (max-width: 991px) {
    font-size: 0.26rem !important;
  }
}
.box_title {
  @media (max-width: 991px) {
    font-size: 0.38rem;
    line-height: 0.38rem;
    margin-bottom: 0.4rem;
  }
}
.dbox_uploadd {
  width: 3rem;
  height: 3rem;
  display: flex;
  background: rgba(196, 196, 204, 0.1);
  // border-radius: 22rpx;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  background-size: cover;
  background-position: center;

  .upload {
    width: 1rem;
    height: 0.83rem;
    margin-bottom: 0.23rem;

    img {
      width: 1rem;
      height: 0.83rem;
    }
  }

  .upload_text {
    height: 0.42rem;
    font-size: 0.3rem;
    color: #1b1c33;
    line-height: 0.42rem;
  }

  .upload_tip {
    height: 0.42rem;
    font-size: 0.3rem;

    color: #8d8e99;
    line-height: 0.42rem;
  }

  .delete {
    position: absolute;
    top: -0.1rem;
    right: -0.1rem;
    width: 0.4rem;
    height: 0.4rem;
  }

  .img {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/settled.vue